<template>
  <div class="modal fade modal-user-edit" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <form>
        <div class="modal-content">
          <div class="modal-header">
            <template v-if="editingExistingUser">Edit Account User</template>
            <template v-else>Add Account User</template>
          </div>
          <div class="modal-body">
            <p class="m-b-lg" v-if="notEditingExistingUser">
              You can add additional users to your account, this gives them full access to all areas except your master account settings and users.
            </p>

            <div class="row">
              <div :class="{'col-sm-12': notEditingExistingUser, 'col-sm-8': editingExistingUser}">
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group-outer">
                      <div class="form-group float-label-control" :class="{ 'has-error': errors.has('name') }">
                        <label for="">Name</label>

                        <input type="text" class="form-control" placeholder="Name" name="name" v-model="name" v-validate="'required'" v-float-label>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group-outer">
                      <div class="form-group float-label-control" :class="{ 'has-error': errors.has('surname') }">
                        <label for="">Surname</label>

                        <input type="text" class="form-control" placeholder="Surname" name="surname" v-model="surname" v-validate="'required'" v-float-label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group-outer">
                  <div class="form-group float-label-control" :class="{ 'has-error': errors.has('email') }">
                    <label for="">Email Address</label>

                    <input type="text" class="form-control" placeholder="Email Address" name="email" v-validate="'required'" v-model="email" v-float-label>
                  </div>
                </div>

                <div class="form-group-">
                  <div class="form-group float-label-control" :class="{ 'has-error': errors.has('mobile') }">
                    <label for="">Mobile Number</label>

                    <input type="text" class="form-control" placeholder="Mobile Number" name="mobile" v-validate="'required'" v-model="mobile" v-float-label>
                  </div>
                </div>
              </div>

              <div class="col-sm-4" v-if="editingExistingUser">
                <ladda-button
                  button-type="button"
                  v-if="accountUserDecorated.isEnabled"
                  class="btn btn-block btn-sm m-b-sm btn-warning"
                  :on-click="handleDisableUser">
                  <i class="fa fa-ban"></i> Disable User
                </ladda-button>
                <ladda-button
                button-type="button"
                v-else
                class="btn btn-block btn-sm m-b-sm btn-success"
                :on-click="handleEnableUser">
                  <i class="fa fa-refresh"></i> Enable User
                </ladda-button>

                <ladda-button
                  button-type="button"
                  v-if="accountUserDecorated.isNotArchived"
                  class="btn btn-block btn-sm m-b-sm btn-danger"
                  :on-click="handleArchiveUser">
                  <i class="fa fa-trash"></i> Archive User
                </ladda-button>
                <ladda-button
                  button-type="button"
                  v-else
                  class="btn btn-block btn-sm m-b-sm btn-success"
                  :on-click="handleRestoreUser">
                  <i class="fa fa-refresh"></i> Restore User
                </ladda-button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <p v-show="editingExistingUser">
                  <strong>Last access:</strong> {{ accountUserDecorated.last_login }}
                </p>

                <p class="small" v-show="notEditingExistingUser">
                  Note: When creating a new user an email will be sent to them so they can set their password.
                </p>

                <template v-if="editingOrCreateChildAdminAccount">
                  <div class="decorative-divider"></div>

                  <h3>System Access</h3>
                  <div class="checkbox checkbox-primary">
                    <input id="checkbox-load-check" class="styled" type="checkbox" v-model="permissionLoadCheck">
                    <label for="checkbox-load-check">
                      Load Check
                    </label>
                  </div>
                  <div class="checkbox checkbox-primary">
                    <input id="checkbox-invoices" class="styled" type="checkbox" v-model="permissionInvoices">
                    <label for="checkbox-invoices">
                      Invoices
                    </label>
                  </div>
                  <div class="checkbox checkbox-primary">
                    <input id="checkbox-payments" class="styled" type="checkbox" v-model="permissionPayments">
                    <label for="checkbox-payments">
                      Payments
                    </label>
                  </div>
                  <div class="checkbox checkbox-primary">
                    <input id="checkbox-reports" class="styled" type="checkbox" v-model="permissionReports">
                    <label for="checkbox-reports">
                      Reports
                    </label>
                  </div>
                  <div class="checkbox checkbox-primary">
                    <input id="checkbox-users" class="styled" type="checkbox" v-model="permissionUsers">
                    <label for="checkbox-users">
                      Users
                    </label>
                  </div>
                  <div class="checkbox checkbox-primary">
                    <input id="checkbox-system-settings" class="styled" type="checkbox" v-model="permissionSettings">
                    <label for="checkbox-system-settings">
                      System Settings
                    </label>
                  </div>
                  <div class="checkbox checkbox-primary">
                    <input id="checkbox-system-adminstrator" class="styled" type="checkbox" v-model="permissionAdministrator">
                    <label for="checkbox-system-adminstrator">
                      System Administrator
                    </label>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>

            <ladda-button v-if="editingExistingUser" type="primary" size="small" :on-click="handleSaveUser">Save</ladda-button>
            <ladda-button v-else type="primary" size="small" :on-click="handleAddUser">Add User</ladda-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { RESET_ACCOUNT_USER, SET_ACCOUNT_USER_ATTRIBUTE, SET_ACCOUNT_USER } from 'vx/mutations'
  import { every, omit, get, merge } from 'lodash'
  import { existingUser, stateMapper } from 'mixins/user'
  import { LaddaButton } from 'components/forms'
  import { notify } from 'utils'
  import $ from 'jquery'

  export default {
    mixins: [existingUser, stateMapper],

    components: {
      LaddaButton
    },

    data () {
      return {
        stateProperty: 'accountUser',
        mutationProperty: SET_ACCOUNT_USER_ATTRIBUTE,
        systemAdministrator: false
      }
    },

    mounted () {
      $(this.$el).on('hidden.bs.modal', this[RESET_ACCOUNT_USER])
      $(this.$el).on('show.bs.modal', () => this.clearValidationErrors())
    },

    beforeDestroy () {
      $(this.$el).off('hidden.bs.modal', this[RESET_ACCOUNT_USER])
      $(this.$el).off('show.bs.modal', () => this.clearValidationErrors())
    },

    computed: {
      ...mapState('user/accountUsers', ['accountUser']),
      ...mapGetters('user/accountUsers', ['accountUserDecorated']),

      /**
       * Determine if we are editing an existing user.
       *
       * @return boolean
       */
      editingExistingUser () {
        return this.accountUser.id !== null
      },

      /**
       * Inverse of above.
       *
       * @return boolean
       */
      notEditingExistingUser () {
        return !this.editingExistingUser
      },

      /**
       * Determine if we are creating or editing a child admin account.
       *
       * @return boolean
       */
      editingOrCreateChildAdminAccount () {
        return this.user.isAdmin
      },

      /**
       * Get and set account user load check permission.
       */
      permissionLoadCheck: {
        get () {
          return get(this.accountUser.permissions, 'load_check', false)
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'permissions.load_check', value })
        }
      },

      /**
       * Get and set account user invoices permission.
       */
      permissionInvoices: {
        get () {
          return get(this.accountUser.permissions, 'invoices', false)
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'permissions.invoices', value })
        }
      },

      /**
       * Get and set account user payments permission.
       */
      permissionPayments: {
        get () {
          return get(this.accountUser.permissions, 'payments', false)
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'permissions.payments', value })
        }
      },

      /**
       * Get and set account user reports permission.
       */
      permissionReports: {
        get () {
          return get(this.accountUser.permissions, 'reports', false)
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'permissions.reports', value })
        }
      },

      /**
       * Get and set account user settings permission.
       */
      permissionSettings: {
        get () {
          return get(this.accountUser.permissions, 'settings', false)
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'permissions.settings', value })
        }
      },

      /**
       * Get and set account user users permission.
       */
      permissionUsers: {
        get () {
          return get(this.accountUser.permissions, 'users', false)
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'permissions.users', value })
        }
      },

      /**
       * Get and set account user administrator permission.
       */
      permissionAdministrator: {
        get () {
          return get(this.accountUser.permissions, 'administrator', false)
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'permissions.administrator', value })
        }
      },

      /**
       * Payload to send with request.
       *
       * @return object
       */
      payload () {
        return {
          name: this.name,
          surname: this.surname,
          email: this.email,
          mobile: this.mobile,
          permissions: {
            load_check: this.permissionLoadCheck,
            invoices: this.permissionInvoices,
            payments: this.permissionPayments,
            reports: this.permissionReports,
            settings: this.permissionSettings,
            users: this.permissionUsers,
            administrator: this.permissionAdministrator
          }
        }
      }
    },

    watch: {
      /**
       * Watch the system administrator checkbox.
       *
       * @param boolean value
       *
       * @return value
       */
      permissionAdministrator (value) {
        // If unchecking and we already have unchecked a permissions option then we won't
        // push the false value through to all the other permissions.
        if (!value && !every(omit(this.accountUser.permissions, 'administrator'))) {
          return
        }

        this.permissionLoadCheck = value
        this.permissionInvoices = value
        this.permissionPayments = value
        this.permissionReports = value
        this.permissionSettings = value
        this.permissionUsers = value
      },

      /**
       * Watch account users permissions for changes, if every permission is ticked
       * then we'll tick the "system administrator" option, and if they have at
       * least one unticked we'll untick the "system administrator" option.
       */
      'accountUser.permissions': {
        handler (permissions) {
          if (every(omit(permissions, 'administrator'))) {
            this.permissionAdministrator = true
          } else {
            this.permissionAdministrator = false
          }
        },
        deep: true
      }
    },

    methods: {
      ...mapActions('user', [
        'disableUser',
        'enableUser',
        'archiveUser',
        'restoreUser',
        'storeUser',
        'updateUser'
      ]),
      ...mapMutations('user/accountUsers', [RESET_ACCOUNT_USER, SET_ACCOUNT_USER]),

      /**
       * Update an account user state after a saving action.
       *
       * @param object response
       *
       * @return Promise
       */
      updateAccountUserState (response) {
        this[SET_ACCOUNT_USER](response.data)

        return Promise.resolve()
      },

      /**
       * Handle disabling an account user.
       *
       * @return Promise
       */
      handleDisableUser () {
        return this.disableUser(this.accountUser.id)
          .then(this.updateAccountUserState)
          .then(this.triggerEvents)
      },

      /**
       * Handle enabling an account user.
       *
       * @return Promise
       */
      handleEnableUser () {
        return this.enableUser(this.accountUser.id)
          .then(this.updateAccountUserState)
          .then(this.triggerEvents)
      },

      /**
       * Handle archiving an account user.
       *
       * @return Promise
       */
      handleArchiveUser () {
        return this.archiveUser(this.accountUser.id)
          .then(this.updateAccountUserState)
          .then(this.triggerEvents)
      },

      /**
       * Handle restoring an account user.
       *
       * @return Promise
       */
      handleRestoreUser () {
        return this.restoreUser(this.accountUser.id)
          .then(this.updateAccountUserState)
          .then(this.triggerEvents)
      },

      /**
       * Handle saving an existing account user.
       *
       * @return Promise
       */
      handleSaveUser () {
        return this.validateAll()
          .then(() => {
            let payload = this.payload

            return this.updateUser({ id: this.accountUser.id, payload })
              .then(this.updateAccountUserState)
              .then(this.triggerEvents)
          })
      },

      /**
       * Handle adding a new user.
       *
       * @return Promise
       */
      handleAddUser () {
        return this.validateAll()
          .then(() => {
            let payload = merge(this.payload, { parent_id: this.user.id, active: true })

            const failedToAdd = (error) => {
              if (error.response && error.response.status === 403) {
                notify.error(error.response.data.error)
              } else {
                notify.error('Unable to add the account user.')
              }
            }

            return this.storeUser(payload)
              .then(this.updateAccountUserState)
              .then(this.triggerEvents)
              .catch(failedToAdd)
          })
      },

      /**
       * Trigger event that the user has been modified in some way.
       *
       * @return void
       */
      triggerEvents () {
        this.$bus.$emit('accountUserUpdated', this.accountUser)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AccountUsersModal.vue?4615cc9c